<template>
  <!-- stepper  -->
  <v-stepper v-model="currentStep" alt-labels>
    <!-- header -->
    <v-stepper-header>
      <v-stepper-step :complete="currentStep > 1" step="1" color="sokoDeep">
        Package
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="currentStep > 2" step="2" color="sokoDeep">
        Contact Info
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="currentStep > 3" step="3" color="sokoDeep">
        Additional info<small>Optional</small>
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="4" color="sokoDeep"> Make Payment </v-stepper-step>
    </v-stepper-header>
    <!-- end header-->

    <!-- body -->
    <v-stepper-items>
      <!-- package -->
      <v-stepper-content step="1">
        <v-card flat>
          <v-card-text>
            <v-form ref="packageForm" v-model="packageValid">
              <v-row>
                <!-- pickup location -->
                <v-col cols="12" md="6">
                  <v-autocomplete
                    label="Pickup Location"
                    v-model="sender.location"
                    :rules="[validationRules.required]"
                    prepend-icon="mdi-map-marker"
                    :items="locationFoundItems"
                    :search-input.sync="senderLocationText"
                    item-text="value"
                    item-value="value"
                    hide-no-data
                  >
                    <template v-slot:item="data">
                      <v-list-item-avatar>
                        <v-icon>mdi-map-marker</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="data.item.value.split(',')[0]"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-html="
                            data.item.value
                              .split(',')
                              .slice(1)
                              .join(', ')
                          "
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>

                <!-- drop-Off location -->
                <v-col cols="12" md="6">
                  <v-autocomplete
                    label="Drop-off Location"
                    :rules="[validationRules.required]"
                    prepend-icon="mdi-map-marker-radius"
                    v-model="recipient.location"
                    :items="locationFoundItems2"
                    :search-input.sync="recipientLocationText"
                    item-text="value"
                    item-value="value"
                    hide-no-data
                  >
                    <template v-slot:item="data">
                      <v-list-item-avatar>
                        <v-icon>mdi-map-marker-radius</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="data.item.value.split(',')[0]"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-html="
                            data.item.value
                              .split(',')
                              .slice(1)
                              .join(', ')
                          "
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>

                <!-- package type -->
                <v-col cols="12" md="6">
                  <v-select
                    v-model="selectItem"
                    :items="items"
                    :rules="[validationRules.required]"
                    label="Package Type"
                    prepend-icon="mdi-package"
                    offset-y
                    required
                  ></v-select>
                </v-col>

                <!-- vehicle type -->
                <v-col cols="12" md="6">
                  <v-select
                    v-model="selectVehicle"
                    prepend-icon="mdi-bus"
                    :items="vehicles"
                    :rules="[validationRules.required]"
                    label="Vehicle Type"
                    offset-y
                    required
                  ></v-select>
                </v-col>

                <!-- pickup date -->
                <v-col cols="12" md="6">
                  <v-row no-gutters>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        prepend-icon="mdi-calendar"
                        label="Delivery Date"
                        readonly
                        single-line
                        :hint="selectedDate.slice(0, 15)"
                        class="custom-color"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" sm="2">
                      <v-select
                        :items="availableYears"
                        label="year"
                        v-model="year"
                        :rules="[validationRules.required]"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-select
                        :items="availableMonths"
                        item-text="name"
                        item-value="abbr"
                        label="month"
                        v-model="month"
                        :value="month"
                        :rules="[validationRules.required]"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="2">
                      <v-select
                        :items="availableDates"
                        label="day"
                        v-model="day"
                        :value="day"
                        :rules="[validationRules.required]"
                      ></v-select
                    ></v-col>
                  </v-row>
                </v-col>

                <!-- pickup time -->
                <v-col cols="12" md="6">
                  <v-row no-gutters>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        prepend-icon="mdi-clock"
                        single-line
                        :label="`Delivery Time (${selectedTime})`"
                        readonly
                        class="custom-color"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-select
                        :items="availableHours"
                        label="hours"
                        v-model="hours"
                        :value="hours"
                        :rules="[validationRules.required]"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="3">
                      <v-select
                        :items="availableMinutes"
                        label="minutes"
                        v-model="minutes"
                        :value="minutes"
                        :rules="[validationRules.required]"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <!-- next -->
            <v-spacer></v-spacer>
            <v-btn
              depressed
              rounded
              color="sokoDeep white--text"
              class="ma-3"
              @click="onPackageFormDone"
              :disabled="!packageValid"
              >next</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <!-- end package -->

      <!-- contact-info -->
      <v-stepper-content step="2">
        <v-card flat>
          <v-card-text>
            <v-form ref="contactForm" v-model="contactValid">
              <v-row>
                <!-- sender name -->
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="sender.name"
                    :rules="[validationRules.required, validationRules.name]"
                    label="Sender's Name"
                    prepend-icon="mdi-run"
                    autocomplete="off"
                    required
                  >
                  </v-text-field>
                </v-col>

                <!-- recipient name -->
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="recipient.name"
                    :rules="[validationRules.required, validationRules.name]"
                    label="Recipient's Name"
                    prepend-icon="mdi-human"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>

                <!-- sender phone number -->
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="1" class="mt-6">
                      <v-icon>mdi-cellphone</v-icon>
                    </v-col>
                    <v-col cols="4" md="3">
                      <v-select
                        v-model="sender.zip"
                        :items="countryCodes"
                        menu-props="auto"
                        label="Zip"
                      ></v-select>
                    </v-col>
                    <v-col cols="7" md="8">
                      <v-text-field
                        v-model="sender.phone"
                        :rules="[
                          validationRules.required,
                          validationRules.phone,
                        ]"
                        label="Sender's Number"
                        autocomplete="off"
                        :maxlength="10"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>

                <!-- recipient phone number -->
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="1" class="mt-6">
                      <v-icon>mdi-cellphone</v-icon>
                    </v-col>
                    <v-col cols="4" md="3">
                      <v-select
                        v-model="recipient.zip"
                        :items="countryCodes"
                        menu-props="auto"
                        label="Zip"
                      ></v-select>
                    </v-col>
                    <v-col cols="7" md="8">
                      <v-text-field
                        v-model="recipient.phone"
                        :rules="[
                          validationRules.required,
                          validationRules.phone,
                        ]"
                        label="Recipient's Number"
                        autocomplete="off"
                        :maxlength="10"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-btn
              outlined
              rounded
              color="sokoDeep"
              class="ma-3"
              @click="currentStep--"
              >previous</v-btn
            >

            <v-spacer></v-spacer>

            <v-btn
              rounded
              color="sokoDeep white--text"
              class="ma-3"
              depressed
              :disabled="!contactValid"
              @click="currentStep++"
              >next</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <!-- end contact-info -->

      <!-- additional info -->
      <v-stepper-content step="3">
        <v-card flat>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="additionalInfo"
                  prepend-icon="mdi-comment"
                  clearable
                  label="Additional Information"
                  outlined
                  color="black"
                  placeholder="You can give additional location details or how the package should be handled."
                ></v-textarea>
                <!-- v-textarea for additional information... not required -->
              </v-col>

              <v-col cols="12" v-if="toPaymentText === 'cannot proceed'">
                <div class="font-weight-bold black--text">
                  <v-icon color="sokoDeep">mdi-information-outline</v-icon>
                  Currently, there is no
                  <span class="sokoDeep--text">{{ selectVehicle }}</span>
                  available to process your delivery. Please change the
                  <a
                    class="sokoDeep--text text-decoration-none"
                    @click="currentStep = 1"
                    >Vehicle Type</a
                  >
                  to proceed...
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-btn
              outlined
              rounded
              color="sokoDeep"
              class="ma-3"
              @click="currentStep--"
              >previous</v-btn
            >
            <v-spacer></v-spacer>

            <v-btn
              rounded
              color="sokoDeep white--text"
              class="ma-3"
              depressed
              :disabled="loadingPayment"
              @click="currentStep++"
              >{{ toPaymentText }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <!-- end additional info -->

      <!-- payment -->
      <v-stepper-content step="4">
        <v-card flat>
          <v-card-text>
            <v-row>
              <!-- Map -->
              <v-col cols="12" md="6">
                <Map :places="places" />
              </v-col>

              <!-- Overview -->
              <v-col cols="12" md="6">
                <v-row>
                  <!-- total distance  and cost -->
                  <v-col cols="6" style="padding-top: 0px"
                    ><v-card
                      height="150px"
                      style="border-top: 3px solid #f55e15"
                    >
                      <v-card-title class="d-block text-center sokoGrey--text"
                        >Distance</v-card-title
                      >
                      <v-card-text
                        class="sokoDeep--text d-flex align-center justify-center text-center"
                      >
                        <h1>{{ totalDistance[0] }}</h1>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer />
                        {{ totalDistance[1] }}
                        <v-icon right>mdi-map-marker-distance</v-icon>
                        <v-spacer />
                      </v-card-actions> </v-card
                  ></v-col>
                  <!-- Total Cost -->
                  <v-col cols="6" style="padding-top: 0px"
                    ><v-card
                      height="150px"
                      style="border-top: 3px solid #f55e15"
                    >
                      <v-card-title class="d-block text-center sokoGrey--text"
                        >Fee</v-card-title
                      >
                      <v-card-text
                        class="sokoDeep--text d-flex align-center justify-center text-center"
                      >
                        <h1>{{ totalCost }}</h1>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer />
                        GHc
                        <v-icon right>mdi-cash-multiple</v-icon>
                        <v-spacer />
                      </v-card-actions> </v-card
                  ></v-col>
                </v-row>
                <v-list>
                  <!-- <v-list-item-group> -->
                  <v-list-item v-for="(item, i) in overview" :key="i">
                    <v-list-item-icon
                      ><v-icon color="sokoDeep" v-text="item.icon"></v-icon
                    ></v-list-item-icon>
                    <v-list-item-content v-text="item.text">
                    </v-list-item-content>
                  </v-list-item>
                  <!-- </v-list-item-group> -->
                </v-list></v-col
              >
              <template v-if="informationToUser !== null">
                <v-col cols="12"
                  ><v-icon color="sokoDeep">mdi-information-outline</v-icon>
                  {{ informationToUser }}</v-col
                >
              </template>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-btn
              outlined
              rounded
              color="sokoDeep"
              class="ma-3"
              @click="currentStep--"
              >previous</v-btn
            >
            <v-spacer />
            <v-btn
              rounded
              class="sokoDeep mt-3 white--text"
              @click="submitOrder"
              :loading="loading"
              depressed
              :disabled="!canSubmit"
              >proceed</v-btn
            >
          </v-card-actions>
        </v-card>

        <!-- user profile dialog -->
        <v-dialog v-model="dialog" max-width="500">
          <v-card>
            <v-card-title color="grey"
              ><v-spacer />Update Profile<v-spacer
            /></v-card-title>
            <v-card-subtitle class="text-center"
              >please complete your profile to continue</v-card-subtitle
            >
            <v-card-text
              ><Profile v-bind:dialog="true" @profileUpdated="onProfileUpdated"
            /></v-card-text>
          </v-card>
        </v-dialog>
        <!-- end user profile dialog -->
      </v-stepper-content>
      <!-- end payment -->
    </v-stepper-items>
    <!-- end body -->
  </v-stepper>
  <!-- end stepper -->
</template>

<script>
import { mapActions } from "vuex";

// Components
import Profile from "@/components/Forms/Profile.vue";
import Map from "@/components/Utils/Map";

// Helpers
import { GetSuggestions } from "@/externals/data/GetSuggestions.js";
import countryCodes from "@/externals/data/CountryCodes.js";
import validationRules from "@/externals/logic/ValidationRules.js";
import {
  timeDates,
  timeMonths,
  timeYears,
  getDayOfWeek,
  destructDate,
  timeHours,
  timeMinutes,
  structDate,
} from "@/externals/data/DateWorker";
import pnf from "@/externals/logic/PhoneNumberFormatter.js";
import {
  calcDistance,
  calcFee,
  addLocs,
  makeOrder,
  initTransact,
  initCheckout,
} from "@/externals/utils/Scheduler.js";

export default {
  name: "Order",

  components: { Profile, Map },

  data: () => ({
    places: ["Accra", "Kumasi"], // default places for Map component

    // form behaviour
    currentStep: 1,
    loading: false,
    loadingPayment: true,
    toPaymentText: "next",
    dialog: false,

    packageValid: true,
    contactValid: true,

    sender: {
      name: "",
      zip: "+233",
      phone: "",
      location: "",
    },
    recipient: {
      name: "",
      zip: "+233",
      phone: "",
      location: "",
    },

    day: 1,
    month: "Dec",
    year: 2020,
    hours: "00",
    minutes: "00",

    additionalInfo: "",
    selectedTimeValue: "",
    selectedDateValue: "",
    date: null,
    time: "",
    today: new Date().toISOString().substr(0, 10),
    selectItem: "",
    selectVehicle: "",

    //prop values
    dateMenu: false,
    timeMenu: false,

    //form validation
    validationRules,
    countryCodes,

    //array of items
    items: [
      "Glassware",
      "Silverware",
      "Food and Groceries",
      "Toiletries",
      "Electronics",
      "Furniture",
      "Other",
    ],

    locationEntries: [],
    locationEntries2: [],
    senderLocationText: null,
    recipientLocationText: null,
  }),

  watch: {
    senderLocationText(newVal) {
      var _vue = this;

      // If less than 3 chars typed, do not search
      if (!newVal || newVal.length <= 1) return;

      // Call the method from the previous section here
      GetSuggestions(newVal)
        .then(function(res) {
          _vue.locationEntries = res;
          // console.log(res);
        })
        .catch(function(err) {
          console.log(err);
          // error handling goes here
        });
    },

    recipientLocationText(newVal) {
      var _vue = this;

      // If less than 3 chars typed, do not search
      if (!newVal || newVal.length <= 1) return;

      // Call the method from the previous section here
      GetSuggestions(newVal)
        .then(function(res) {
          _vue.locationEntries2 = res;
        })
        .catch(function(err) {
          console.log(err);
          // error handling goes here
        });
    },

    day() {
      if (!this.availableMinutes.includes(this.minutes))
        this.minutes = this.availableMinutes[0];
      if (!this.availableHours.includes(this.hours))
        this.hours = this.availableHours[0];
    },

    month() {
      if (!this.availableDates.includes(this.day))
        this.day = this.availableDates[0];
      if (!this.availableMinutes.includes(this.minutes))
        this.minutes = this.availableMinutes[0];
      if (!this.availableHours.includes(this.hours))
        this.hours = this.availableHours[0];
    },

    year() {
      if (!this.availableMonths.includes(this.month))
        this.month = this.availableMonths[0].abbr;
      if (!this.availableMinutes.includes(this.minutes))
        this.minutes = this.availableMinutes[0];
      if (!this.availableHours.includes(this.hours))
        this.hours = this.availableHours[0];
    },
  },

  //computed
  computed: {
    availableDates() {
      const dates = timeDates({ month: this.month, year: this.year }, true);
      return dates;
    },

    availableMonths() {
      return timeMonths(true, this.year);
    },

    availableYears() {
      return timeYears();
    },

    availableHours() {
      return timeHours(this.day, this.month, this.year);
    },

    availableMinutes() {
      return timeMinutes(this.day, this.month, this.year, this.hours);
    },

    weekday() {
      return getDayOfWeek(this.day, this.month, this.year);
    },

    canSubmit() {
      return this.packageValid && this.contactValid;
    },

    locationFoundItems() {
      return this.locationEntries;
    },

    locationFoundItems2() {
      return this.locationEntries2;
    },

    vehicles() {
      const vehicleRate = this.$store.getters.getCollection("vehicles").values;
      let vehicles = [];
      for (let item in vehicleRate) vehicles.push(item);

      return vehicles;
    },

    userInfo() {
      // get current logged in user if user is authenticated
      return this.$store.getters.getCollection("user");
    },

    distanceInfo() {
      return this.$store.getters.getCollection("distance");
    },

    totalDistance() {
      let distance = 0;
      if (!this.distanceInfo.distance) return [distance, "m"];
      else distance = parseFloat(this.distanceInfo.distance.split(" ")[0]);
      return [distance, this.distanceInfo.distance.split(" ")[1]];
    },

    totalCost() {
      let costInfo = this.costInfo;
      let cost = 0;
      if (!costInfo.charge) return cost;
      else cost = parseFloat(costInfo.charge).toFixed(2);
      return cost;
    },

    costInfo() {
      return this.$store.getters.getCollection("cost");
    },

    selectedTime() {
      if (this.hours && this.minutes) {
        let checkhour = parseInt(this.hours);

        let suffix = "";
        suffix = checkhour >= 0 && checkhour <= 11 ? "am" : "pm";
        if (checkhour == 0) {
          checkhour = 12;
        }
        if (suffix == "pm" && checkhour != 12) {
          checkhour = checkhour - 12;
        }
        return `${checkhour}:${this.minutes} ${suffix}`;
      } else return "";
    },

    selectedDate() {
      if (this.day && this.month && this.year) {
        return structDate(this.day, this.month, this.year);
      } else return "";
    },

    overview() {
      return [
        { text: `Delivering ${this.selectItem}`, icon: "mdi-package" },
        { text: `By ${this.selectVehicle}`, icon: "mdi-bus" },
        {
          text: `From ${this.sender.location}`,
          icon: "mdi-map-marker",
        },
        {
          text: `To ${this.recipient.location}`,
          icon: "mdi-map-marker-radius",
        },
        {
          text: `On ${this.selectedDate.slice(0, 15)}, ${this.selectedTime}`,
          icon: "mdi-calendar",
        },
      ];
    },

    informationToUser() {
      let costInfo = this.$store.getters.getCollection("cost");
      if (costInfo.vehicle && this.selectVehicle !== costInfo.vehicle)
        return `All the ${this.selectVehicle}s on SokoDelivery are currently not available but we found a ${costInfo.vehicle} for your delivery.`;
      else return null;
    },
  },
  //methods or functions
  methods: {
    //import makeFetch from from fetchvigator
    ...mapActions(["makeFetch"]),

    getFormData() {
      return {
        recepientname: this.recipient.name,
        recepientphone: pnf.structure(this.recipient.zip, this.recipient.phone),
        dropoff_location: this.recipient.location,
        sendername: this.sender.name,
        senderphone: pnf.structure(this.sender.zip, this.sender.phone),
        pickup_location: this.sender.location,
        itemtype: this.selectItem,
        vehicletype: this.selectVehicle,
        orderstatus: "pending",
        deliverydate: this.selectedDate,
        deliverytime: this.selectedTime,
        extradescription: this.additionalInfo,
        merchantId: this.costInfo.merchantId,
      };
    },

    setTime() {
      //settime function
      this.selectedTime = this.time;
      this.$refs.timeMenu.save(this.time);
    },

    setDate() {
      //set date function
      this.selectedDate = this.date;
      this.$refs.dateMenu.save(this.date);
    },

    allowedHours: (v) => v >= 8 && v <= 17,

    reset() {
      //function to reset the fields
      this.recipient = { name: "", location: "", phone: "" };
      this.sender.location = "";
      this.selectItem = "";
      this.selectVehicle = "";
      this.additionalInfo = "";
    },

    resetValidation() {
      //function to reset the validation
      this.$refs.packageForm.resetValidation();
      this.$refs.contactForm.resetValidation();
    },

    updatePlaces() {
      this.places = [...[], this.sender.location, this.recipient.location];
    },

    async onPackageFormDone() {
      this.loadingPayment = true;
      this.toPaymentText = "calc'ing cost";

      this.sender.name = this.userInfo.fname
        ? `${this.userInfo.fname} ${this.userInfo.lname}`
        : "";

      if (this.userInfo.phonenumber !== "") {
        const phoneNzip = pnf.destructure(this.userInfo.phonenumber);
        this.sender.zip = phoneNzip[0];
        this.sender.phone = phoneNzip[1];
      } else this.sender.phone = "";

      this.currentStep++;

      await addLocs(this.sender.location, this.recipient.location);

      this.updatePlaces();

      await calcDistance(this.sender.location, this.recipient.location);
      const res = await calcFee(
        this.distanceInfo,
        this.selectVehicle,
        this.recipient.location
      );

      if (!res) this.toPaymentText = "cannot proceed";
      else this.toPaymentText = "next";
      this.loadingPayment = !res;
    },

    onProfileUpdated(event) {
      this.dialog = false;
      // console.log(event.andContinue);
      if (event.andContinue === true) this.submitOrder();
    },

    async submitOrder() {
      if (
        !this.userInfo.email ||
        !this.userInfo.fname ||
        !this.userInfo.lname ||
        !this.userInfo.phonenumber
      ) {
        this.dialog = true;
        return;
      }
      //submit order check
      else if (
        //checks if pickupform is validated and dropoff form is validated
        this.$refs.packageForm.validate() &&
        this.$refs.contactForm.validate()
      ) {
        this.loading = true;
        const formFields = this.getFormData();

        const response = await makeOrder(formFields);
        this.loading = false;

        this.isSuccess = response;

        if (this.isSuccess) {
          // add new order to ui
          // this.$store.state.fetchvigator.collection.orders.shift(formFields);

          //checks if its successful
          this.$emit("orderAlert", {
            type: "success",
            msg: formFields,
          });
          this.reset(); //reset the fields and validation
          this.resetValidation();
          this.currentStep = 1;
        } else {
          this.$emit("orderAlert", { type: "failure" });
          this.loading = false;
          return;
        }

        const latestOrder = response;

        const transaction = await initTransact(this.costInfo, latestOrder);

        // console.log(transaction);

        initCheckout(transaction, this.costInfo, latestOrder);
      }
    },
  },

  mounted() {
    const today = destructDate(new Date());
    this.day = today[0];
    this.month = today[1];
    this.year = today[2];
    this.hours = today[3];
    this.minutes = today[4];
  },
};
</script>

<style style>
.v-form i.v-icon,
.v-form .v-text-field i.v-icon {
  color: #000 !important;
}

.custom-color * {
  color: #000 !important;
}
</style>
